import React from "react";
import PropTypes from "prop-types";
import {
  Input,
  Button,
  Form,
  Space,
  DatePicker,
  Col,
  Row,
  Card,
  TreeSelect,
} from "antd";
import { useTranslation } from "react-i18next";
const { RangePicker } = DatePicker;
const { TreeNode } = TreeSelect;
const FormSearch = ({
  treeSelectProps,
  formSearch,
  handleSearch,
  handleRefresh,
  handleNewShift,
  handleShowModalDelete,
  dates,
  setDates,
  handleDeleteSelectRows,
  selectedRowKeys,
  loadingDeleteRows,
}) => {
  const { t } = useTranslation();
  const { treeData, treeDataDepartmentValue } = treeSelectProps;
  const onChangeRangePicker = (value) => {
    if (value?.length === 2) {
      setDates(value);
    } else {
      setDates([]);
    }
  };

  return (
    <>
      <Card>
        <Form
          form={formSearch}
          layout="vertical"
          autoComplete="off"
          className="pl-1"
        >
          <Row gutter={10}>
            <Col lg={{ span: 6 }} sm={{ span: 6 }} xs={{ span: 24 }}>
              <Form.Item
                name="shiftName"
                label={t("shiftAttendanceName") + ": "}
                rules={[
                  {
                    message: t("validateShiftAttendanceName"),
                    type: "string",
                    min: 1,
                  },
                ]}
              >
                <Input
                  placeholder={t("placeHolderShiftAttendanceName")}
                  allowClear={true}
                />
              </Form.Item>
            </Col>

            <Col lg={{ span: 6 }} sm={{ span: 12 }} xs={{ span: 24 }}>
              <Form.Item
                name="department"
                label={t("companyDepartmentAndGroup") + ":"}
              >
                <TreeSelect
                  showSearch
                  treeNodeFilterProp="title"
                  style={{ width: "100%" }}
                  value={treeDataDepartmentValue}
                  placeholder={t("placeHolderSelectCompanyDepartmentAndGroup")}
                  allowClear
                  onChange={() => handleSearch()}
                >
                  {treeData?.map((data) => {
                    return (
                      <TreeNode
                        key={data.key}
                        value={data.value}
                        title={data.title}
                      >
                        {data.children.length > 0
                          ? data.children.map((child) => {
                              return (
                                <TreeNode
                                  key={child.key}
                                  value={child.value}
                                  title={child.title}
                                >
                                  {child.children.length > 0
                                    ? child.children.map((childOfChild) => {
                                        return (
                                          <TreeNode
                                            key={childOfChild.key}
                                            value={childOfChild.value}
                                            title={childOfChild.title}
                                          />
                                        );
                                      })
                                    : null}
                                </TreeNode>
                              );
                            })
                          : null}
                      </TreeNode>
                    );
                  })}
                </TreeSelect>
              </Form.Item>
            </Col>

            <Col className="range-picker">
              <Form.Item label={t("shiftAttendanceTimePeriod") + ":"} />
              <RangePicker
                showTime={{ format: "HH:mm" }}
                format="DD-MM-YYYY HH:mm"
                value={dates}
                placeholder={[t("startTime"), t("endTime")]}
                onChange={onChangeRangePicker}
              />
            </Col>

            <Col lg={{ span: 24 }} sm={{ span: 24 }} xs={{ span: 24 }}>
              <Form.Item className="form-button d-block text-left">
                <Space>
                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => handleSearch()}
                  >
                    {t("search")}
                  </Button>

                  <Button type="primary" onClick={handleNewShift}>
                    {t("create")}
                  </Button>

                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => handleRefresh()}
                  >
                    {t("reload")}
                  </Button>

                  <Button
                    type="primary"
                    htmlType="button"
                    onClick={() => handleShowModalDelete()}
                  >
                    {t("deleteByTimePeriod")}
                  </Button>
                  <Button
                    disabled={selectedRowKeys.length === 0}
                    loading={loadingDeleteRows}
                    type="danger"
                    htmlType="button"
                    onClick={() => handleDeleteSelectRows()}
                  >
                    {t("delete")}
                  </Button>
                </Space>
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Card>
    </>
  );
};
FormSearch.propTypes = {
  formSearch: PropTypes.any,
  handleSearch: PropTypes.func,
  handleRefresh: PropTypes.func,
  handleNewShift: PropTypes.func,
  listDepartment: PropTypes.any,
  handleShowModalDelete: PropTypes.func,
  handleDeleteSelectRows: PropTypes.func,
  selectedRowKeys: PropTypes.any,
  loadingDeleteRows: PropTypes.any,
};
export default FormSearch;
